export default __webpack_public_path__ + "static/media/ship.aebdbed5.svg";